<template>
  <div class="breadcrumb-container">
    <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="item in levelList" :key="item.path">
        <span @click="breadcrumb(item)" :class="item.path==Path?'spanSelect':'span'">{{item.name}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
  export default{
    data() {
      return{
        levelList: [],
      }
    },
    computed:{
      Path(){
        return this.$route.path
      }
    },
    mounted() {
    },
    watch: {
        $route() {
            this.getBreadcrumb()  //监听路由变化
        }
    },
    created(){
        this.getBreadcrumb()
    },
    methods:{
      getBreadcrumb() {
          let matched = this.$route.matched.filter(item => item.name)  //获取路由信息，并过滤保留路由名称信息存入数组
          this.levelList = matched
          // console.log(matched)
      },
      breadcrumb(e){
          this.$router.push(e.path)
      }
    }
  }
</script>

<style scoped>
 .breadcrumb-container{
   padding: 20px;
 }
 .spanSelect{
   font-weight: bold;
 }
</style>
